import { ExternalLink } from 'lucide-react'
import { motion } from 'motion/react'
import { useLocale } from '../context/LocaleContext'
import { iconByKey } from '../lib/icons'
import { SectionHeading } from './SectionHeading'

export function EducationSection() {
  const { content } = useLocale()
  const { ui, education } = content
  return (
    <section className="education-section section-shell" id="education">
      <SectionHeading eyebrow={ui.educationEyebrow} title={ui.educationTitle} intro={ui.educationIntro} />
      <div className="education-grid">
        {education.map((entry, index) => {
          const Icon = iconByKey[entry.icon]
          return (
            <motion.article key={entry.id} id={`education-${entry.id}`} className="education-card" initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: '-10%' }} transition={{ delay: index * 0.04 }}>
              <span className="education-icon"><Icon /></span>
              <p>{entry.period}</p>
              <h3>{entry.degree}</h3>
              <h4>{entry.institution}</h4>
              <ul>{entry.details.map((detail) => <li key={detail}>{detail}</li>)}</ul>
              <a href={entry.website} target="_blank" rel="noreferrer" aria-label={`${ui.visitWebsite}: ${entry.institution}`}><ExternalLink size={17} /></a>
            </motion.article>
          )
        })}
      </div>
    </section>
  )
}
